import { TopicsEnum } from './constants';
import { HubTopicParamsModel, LoadTopicParamsModel, UliTopicParamsModel } from './models';

export class ServerMessagesSetUpConnection {
  public static readonly type = '[ServerMessages] Set Up Connection';
}

export class ServerMessagesDisconnect {
  public static readonly type = '[ServerMessages] Disconnect';
}

export class ServerMessagesHubTopic {
  constructor(public payload: HubTopicParamsModel) {}

  public static readonly type = '[ServerMessages] Hub Topic';
}

export class ServerMessagesLoadTopic {
  public static readonly type = '[ServerMessages] Load Topic';

  constructor(public payload: LoadTopicParamsModel) {}
}

export class ServerMessagesUliTopic {
  public static readonly type = '[ServerMessages] Uli Topic';

  constructor(public payload: UliTopicParamsModel) {}
}

export class ServerMessagesRemoveAllocateUliAfterCreationMessage {
  public static readonly type = '[ServerMessages] Remove Uli Item Allocate After Creation Message';

  constructor(public payload: string) {}
}

export class ServerMessagesRemoveUliAutoAllocationMessage {
  public static readonly type = '[ServerMessages] Remove Uli Auto Allocation Message';

  constructor(public payload: string) {}
}

export class ServerMessagesUnsubscribeFromTopic {
  constructor(public topic: TopicsEnum) {}

  public static readonly type = '[ServerMessages] Unsubscribe From Topic';
}

export class ServerMessagesInitialState {
  public static readonly type = '[ServerMessages] Set Initial State';
}

export class ServerMessagesNotaFiscalTopic {
  static readonly type = '[ServerMessages] Nota Fiscal Topic';

  constructor(public payload: HubTopicParamsModel) {}
}
